import {Directive, Input, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, UntypedFormGroup} from '@angular/forms';

import {InSubject} from '@atmi/core/utils';

import {BehaviorSubject, Subject} from 'rxjs';
import {first, switchMap, takeUntil} from 'rxjs/operators';

@Directive()
export abstract class BaseCtrlValueAccessorFormComponent<T extends {
  [key: string]: any;
}> implements ControlValueAccessor, OnInit, OnDestroy {

  @Input() @InSubject() form?: UntypedFormGroup;
  readonly formChange = new BehaviorSubject<UntypedFormGroup | undefined>(undefined);

  get value(): T {
    return this.form && this.form.value;
  }

  set value(value: T) {
    if (this.form) {
      this.form.setValue(value);

      this.onChange(value);
      this.onTouched();
    }
  }

  protected readonly unsubscription$ = new Subject();

  constructor() {
    this.formChange.pipe(
      first((form): form is UntypedFormGroup => !!form),
      switchMap((form) => form.valueChanges),
      takeUntil(this.unsubscription$),
    ).subscribe((value) => {
      this.onChange(value);
      this.onTouched();
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.unsubscription$.next(null);
    this.unsubscription$.complete();
  }

  onChange: any = () => {
  }
  onTouched: any = () => {
  }

  registerOnChange(fn: () => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  writeValue(value: T) {
    if (!this.form) {
      throw new Error('Cannot write to the form without a valid instance');
    }

    if (value) {
      this.value = value;
    } else {
      this.form.reset();
    }
  }
}
